<form [formGroup]="formService" (ngSubmit)="saveService()">
  <p-dialog header="Header" [modal]="true" [(visible)]="modalForm" [style]="{width: '35vw'}">
    <ng-template pTemplate="header">
      <h4 class="text-[#27368A] font-extrabold text-xl">Datos de la actividad</h4>
    </ng-template>
    <div class="grid grid-cols-1 gap-1 justify-center align-middle h-min box-content">
      <div class="mb-2">
        <label for="" class="text-[#27368A] font-bold text-base" >Seleccionar actividad: </label>
          <select tabindex="1"  (change)="onChange($event)"
          class="flex align-middle items-center  bg-white rounded-lg w-full h-9 px-2  text-black font-medium text-base border-[rgb(39,54,138)] border-2">
          <option value="">-</option>
          <ng-container *ngFor="let service of services; let i = index" >
          <option [value]="i" class="bg-white  hover:bg-[#27368A]">{{ service.name }}
            </option>
          </ng-container>
          </select>
      </div>
      <div class="mb-2" *ngIf="userSelectedService !== undefined">
        <label for="" class="text-[#27368A] font-bold text-base" >Seleccionar perfil: </label>
          <select formControlName="service" tabindex="2" (change)="onChangeProfile($event)"  [ngClass]="{'border-red-600' : formService.get('service')?.touched && formService.get('service')?.hasError('required')}"
          class="flex align-middle items-center  bg-white rounded-lg w-full h-9 px-2  text-black font-medium text-base border-[#27368A] border-2">
            <option [value]="i"  *ngFor="let profile of userSelectedService.profiles; let i = index" class="bg-white  hover:bg-[#27368A]">{{ profile?.name }}
            </option>
          </select>
        <div *ngIf="formService.controls['service'].touched">
          <p *ngIf="formService.get('service')?.hasError('required')" class="text-red-600 text-xs font-bold">Campo obligatorio</p>
        </div>
      </div>
      <div class="flex flex-row gap-4">
        <div class="flex flex-col">
          <div class="mb-2">
            <label for="date" class="text-[#27368A] font-bold text-base">Seleccionar fecha: </label>
            <input formControlName="date" tabindex="3" type="date" id="date" [ngClass]="{'border-red-600' : formService.get('date')?.touched && formService.get('date')?.hasError('required')}" class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-[165px]">
            <div *ngIf="formService.controls['date'].touched">
              <p *ngIf="formService.get('date')?.hasError('required')" class="text-red-600 text-xs font-bold">Campo obligatorio</p>
            </div>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="mb-2">
            <label for="date" class="text-[#27368A] font-bold text-base">Seleccionar hora: </label>
            <select formControlName="hour" tabindex="4" [ngClass]="{'border-red-600' : formService.get('hour')?.touched && formService.get('hour')?.hasError('required')}" class="flex align-middle items-center  bg-white rounded-lg w-[165px] h-10 px-2  text-black font-medium text-base border-[#27368A] border-2">
              <option [value]="hour" *ngFor="let hour of hours" class="bg-white  hover:bg-[#27368A]">{{ hour }}</option>
            </select>
            <div *ngIf="formService.controls['hour'].touched">
              <p *ngIf="formService.get('hour')?.hasError('required')" class="text-red-600 text-xs font-bold">Campo obligatorio</p>
            </div>
          </div>
      </div>
    </div>
    <p class="text-[#27368A] font-bold text-base">Seleccionar plazas: </p>
    <div class="flex flex-row gap-5 mb-2">
      <div class="flex flex-col gap-1 ">
        <input formControlName="units" tabindex="5" type="number" value="0" id="seats"
        (change)="calculateAmountService()"
        class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-[165px] ">
      </div>
    </div>
    <div class="flex flex-row gap-1" >
      <label class="text-[#27368A] font-bold text-lg">Precio: </label>
      <p class="text-[#8A8A8A] font-bold text-lg">{{ userSelectedProfile?.price | currency: 'EUR' }} </p>
    </div>
    <div class="flex flex-row gap-1">
      <label class="text-[#27368A] font-bold text-lg">Importe total: </label>
      <p class="text-[#8A8A8A] font-bold text-lg" >{{ this.amountBookingService | currency: 'EUR' }} </p>
    </div>
    <label for="" class="text-[#27368A] font-bold text-base mt-0 ">Notas:</label>
    <textarea formControlName="notes" tabindex="6" id="Textarea" name="Textarea" rows="2" cols="25"
    class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-84 mb-2 mt-0"></textarea>
    <div class="flex justify-end">
      <button
      class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-6 hover:bg-[#27368A]">Guardar</button>
    </div>
    </div>
  </p-dialog>
</form>
